import React from 'react';
import WhiteBellIcon from '../../../../../icons/white-bell-icon.svg';

import styles from './Disclaimer.module.scss';

export default class Disclaimer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      urlClaims: '#',
      urlInfo: '#'
    };
  }

  componentDidMount = () => {
    const urlInfo = process.env.REACT_APP_INF_DEL_TRABAJADOR_SSO_URL;
    const complaintsURL = process.env.REACT_APP_DENUNCIAS_URL;
    const accessToken = localStorage.getItem('AccessToken');

      
    const ssoUrlClaims = `${complaintsURL}${accessToken}&rut=${this.props.companyId}`;
    const ssoUrlInfo = `${urlInfo}?token=${accessToken}&rut=${this.props.companyId}`;


    this.setState({
      urlClaims: ssoUrlClaims,
      urlInfo: ssoUrlInfo
    });

  };

  handleDisclaimerURL(event) {
    event.preventDefault();

    window.open(this.state.urlClaims, '__blank', 'noopener=yes');
  }

  handleInfoURL(event) {
    event.preventDefault();

    window.open(this.state.urlInfo, '__blank', 'noopener=yes');
  }

  render() {
    return (
      <div id='disclaimerBanner' className={styles.root}>
        <img
          id='disclaimerBanner_whiteBellIcon'
          src={WhiteBellIcon}
          alt='White bell icon'
          className={styles.whiteBellIcon}
        />
        <div className={styles.divContainerMessage}>
          <p id='disclaimerBanner_paragraph' className={styles.disclaimerParagraph}>
            - Si necesitas enviar o descargar una Denuncia en línea, recuerda utilizar la funcionalidad Denuncias, 
            puedes ingresar desde
            {' '}
            <a
              id='disclaimerBanner_link'
              className={styles.disclaimerLink}
              onClick={(event) => this.handleDisclaimerURL(event)}
            >
              aquí.
            </a>
          </p>
          <p id='disclaimerBanner_paragraph1' className={styles.disclaimerParagraph}>
            - Para acceder al historial de documentos de tu trabajador, 
            puedes ingresar a la funcionalidad Información del Trabajador, haciendo click
            {' '}
            <a
              id='disclaimerBanner_link'
              className={styles.disclaimerLink}
              onClick={(event) => this.handleInfoURL(event)}
            >
              aquí.
            </a>
          </p>
        </div>
      </div>
    );
  }
}
